/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Related_Title_LeadInputs */

const en_services_related_title_lead = /** @type {(inputs: Services_Related_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Often booked`)
};

const pl_services_related_title_lead = /** @type {(inputs: Services_Related_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Często rezerwowane`)
};

/**
* | output |
* | --- |
* | "Often booked" |
*
* @param {Services_Related_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_related_title_lead = /** @type {((inputs?: Services_Related_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Related_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_related_title_lead(inputs)
	return en_services_related_title_lead(inputs)
});